import Api from './Api';

class TeamApi extends Api {
  url = 'teams';
}

const singleton = new TeamApi();
export default singleton;
